import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24e3a2b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar-week" }

import { PropType } from 'vue'
import WidgetDay from '@/components/booking-widget/WidgetDay.vue'
import { MinimumTimeslot } from '@/models/public/service.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetWeek',
  props: {
  days: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  slots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  timeSlots: {
    type: Array as PropType<number[]>,
    required: true,
  },
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (day, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: day,
        class: "calendar-week__day"
      }, [
        _createVNode(WidgetDay, {
          "with-labels": index === 0,
          day: day,
          slots: __props.slots,
          "time-slots": __props.timeSlots,
          "selected-slots": __props.selectedSlots,
          onOnClick: _cache[0] || (_cache[0] = (value) => emits('onClick', value))
        }, null, 8, ["with-labels", "day", "slots", "time-slots", "selected-slots"])
      ]))
    }), 128))
  ]))
}
}

})